import React from 'react'

import { useAppSelector } from '../../../../App/Hooks/reduxHooks'
import {
  activityCategorySelector,
  activityListSelector,
} from '../../../../App/store/features/activity/activitySlice'
import { personListSelector } from '../../../../App/store/features/person/personSlice'
import { IAddedActivity } from '../../Appointment/AddActivityViewSwitch/IAddActivity'
import { ICrudActivityDetails } from '../../types/ICrudActivityDetails'

import { ActivityList } from './ActivityList'
import { ButtonContainer } from './ButtonContainer/ButtonContainer'
import { ActivityContainer, ActivityUL } from './style'

interface IProps {
  selectedPersonName?: string
  selectedActivityArray: IAddedActivity[]
  setSelectedActivityArray: (activities: ICrudActivityDetails) => void
  setSelectViewOpen: (viewSwitch: 'activity' | 'menu') => void
}

export const AppointmentActivity = ({
  setSelectViewOpen,
  selectedActivityArray,
  setSelectedActivityArray,
  selectedPersonName,
}: IProps) => {
  const activityCategories = useAppSelector(activityCategorySelector)
  const activityList = useAppSelector(activityListSelector)
  const personList = useAppSelector(personListSelector)

  if (!activityCategories || !activityList || !personList) {
    return null
  }

  return (
    <>
      <ButtonContainer setSelectViewOpen={setSelectViewOpen} />
      <ActivityContainer>
        <ActivityUL>
          <ActivityList
            setSelectedActivityArray={setSelectedActivityArray}
            selectedActivityArray={selectedActivityArray}
            personList={personList}
            selectedPersonName={selectedPersonName}
          />
        </ActivityUL>
      </ActivityContainer>
    </>
  )
}
